exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-adblue-js": () => import("./../../../src/pages/adblue.js" /* webpackChunkName: "component---src-pages-adblue-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-regeneration-js": () => import("./../../../src/pages/regeneration.js" /* webpackChunkName: "component---src-pages-regeneration-js" */)
}

